var _circle, _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOrganizationEmptyState(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 212,
    height: 197,
    viewBox: "0 0 212 197",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 113.092,
    cy: 97.38,
    r: 97.042,
    fill: "#ECEEF5"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "9eq9y2lela",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 4,
    width: 212,
    height: 193
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M206.775 116.416c-6.87 24.586-16.892 41.467-38.549 57.089a13.63 13.63 0 0 1-4.671 2.144l-81.872 20.468c-1.446.361-2.94.495-4.428.395l-52.839-3.544a14.314 14.314 0 0 1-10.05-5.135l-10.75-12.944A14.311 14.311 0 0 1 .34 164.887L9.15 18.381c.5-8.322 7.981-14.456 16.24-13.316l93.371 12.89c1.437.198 2.897.177 4.328-.064l71.213-11.966c9.062-1.523 17.2 5.759 16.762 14.938-1.926 40.377-3.456 92.57-4.289 95.553z",
    fill: "#ECEEF5"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#9eq9y2lela)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 12.544,
    y: 40.228,
    width: 184.373,
    height: 146.303,
    rx: 3.25,
    transform: "rotate(-6.956 12.544 40.228)",
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EAEDF3",
    d: "m27.049 81.4 49.953-6.094 3.038 24.903-49.953 6.094zM45.949 131.637l33.882-4.134.97 7.952-33.882 4.134zM101.948 123.637l33.882-4.134.97 7.952-33.882 4.134zM158.948 116.637l33.882-4.134.97 7.952-33.882 4.134z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.7 140.363a3.987 3.987 0 0 1-4.552-3.359 3.998 3.998 0 0 1 3.359-4.552 4.008 4.008 0 0 1 4.551 3.359 3.998 3.998 0 0 1-3.359 4.552zm1.04-4.945-.016.003c.134-.163.099-.394-.08-.526a.368.368 0 0 0-.509.077l-1.454 1.989-.836-.617c-.178-.131-.41-.096-.525.08a.342.342 0 0 0 .077.51l1.138.839c.162.134.394.099.525-.079l1.68-2.276z",
    fill: "#0F8461"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.7 132.363a3.977 3.977 0 0 1-3.729-1.461 3.979 3.979 0 0 1-.596-3.955 4.01 4.01 0 0 1 3.132-2.495 4.004 4.004 0 0 1 3.712 1.463 3.981 3.981 0 0 1 .597 3.956 3.97 3.97 0 0 1-3.117 2.492zm-.895-5.933a.37.37 0 0 0-.315.427l.26 1.73c.034.216.211.348.428.315a.37.37 0 0 0 .315-.427l-.261-1.73a.38.38 0 0 0-.427-.315zm.027 3.535c.042.279.291.462.57.42a.503.503 0 0 0 .419-.569.514.514 0 0 0-.569-.419.502.502 0 0 0-.42.568z",
    fill: "#E53935"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.699 125.363a3.987 3.987 0 0 1-4.551-3.359 3.997 3.997 0 0 1 3.359-4.552 4.008 4.008 0 0 1 4.551 3.359 3.997 3.997 0 0 1-3.359 4.552zm1.04-4.945-.015.003c.134-.163.099-.394-.079-.526a.368.368 0 0 0-.51.077l-1.454 1.989-.836-.617c-.178-.131-.409-.096-.525.08a.342.342 0 0 0 .077.51l1.138.839c.162.134.394.099.525-.079l1.679-2.276z",
    fill: "#0F8461"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EAEDF3",
    d: "m83.549 74.582 49.953-6.094 3.038 24.903-49.953 6.094zM140.011 67.191l49.953-6.094L193.002 86l-49.953 6.094zM23 48.603l10.374-1.266.904 7.41-10.374 1.266zM26 71.288l32.38-3.95.473 3.867-32.381 3.95zM33 119.288l20.473-2.498.472 3.868-20.473 2.497z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D6DAE4",
    d: "m16.229 63.552 181.454-22.138.04.33L16.269 63.883z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrganizationEmptyState);
export default __webpack_public_path__ + "static/media/organization-empty-state.3dde27bc7a3ce8de7b855bc37ac4c44c.svg";
export { ForwardRef as ReactComponent };